import {} from "gatsby"

export const appServerHost = location => {
  const marketingSiteHost = location?.hostname

  if (!marketingSiteHost) {
    return "capsulecrm.com"
  }

  if (marketingSiteHost === "localhost") {
    return "staging.capsule.run"
  } else if (
    marketingSiteHost === "staging.capsule.run" ||
    marketingSiteHost === "draft.capsulecrm.com"
  ) {
    return "staging.capsule.run"
  } else {
    return "capsulecrm.com"
  }
  // if (process.env.GATSBY_BUILD_ENV === "development") {
  //   return "capsule.run"
  // } else if (process.env.GATSBY_BUILD_ENV === "staging") {
  //   return "staging.capsule.run"
  // } else {
  //   return "capsulecrm.com"
  // }
}
